import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as xlsx from "xlsx";
import ExcelIcon from "../../../assets/excelicon.png";
import Plus from "../../../assets/plus.svg";
import UploadCloud from "../../../assets/upload-cloud.svg";
import UploadImage from "../../../assets/upload-image.svg";
import server from "../../server";
import DashboardContext from "../Context/DashboardContext";
import Allproducts from "../Dashboard/Layout/Allproducts";
import InventoryTable from "./Layout/InventoryTable";
import Rating from "./Layout/Rating";

import CircularProgressWithLabel from "./Layout/CircularProgressWithLabel";

import { toast } from "react-toastify";
import io from "socket.io-client";
import useStore from "../stores.ts";

// same origin version

const topRightToastStyles = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

// let socket;

// if (localStorage.getItem("adminuser")) {
const socket = io(`${server}/admin/sync`, {
  auth: { token: localStorage.getItem("accessToken") },
  closeOnBeforeunload: true,
  autoConnect: false,
  reconnectionDelay: 300,
});
socket.on("connect", () => {
  console.log("Connected to socket!");
});
socket.on("disconnect", () => {
  console.log("Disconnected to socket!");
});
// }
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
const Inventory = () => {
  const { products, setProducts } = useStore();

  const [jsonproducts, setJson] = useState();
  const [filename, setfilename] = useState();
  const context = useContext(DashboardContext);

  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);

  const { loading, setLoading } = context;
  const [name, setName] = useState();
  const [category, setCategory] = useState();
  const [subcategory, setSubcategory] = useState();
  const [labelChecked, setLabelChecked] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setJson([]);
    setfilename();
    if (!loading) dataProducts();
  };

  const dataProducts = async (initial = false) => {
    console.log("dataProducts");
    if ((initial && products?.length) || loading) {
      return;
    }
    setLoading(true);
    // console.log("inside fetch")
    const result = await axios.get(`${server}/admin/products`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    // console.log("alll products before ", result.data);
    setProducts(result.data);
    // console.log(result.data[0]);
    await delay(1000);
    setLoading(false);
  };

  const fetchLabelCodeData = async () => {
    const result = await axios.get(
      `${server}/admin/products-sortedbylabelcode`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      },
    );
    // setProductsByLabelCode(result.data);
    setProducts(result.data);
  };

  const UploadImagesInDB = async () => {
    if (jsonproducts.length === 0) {
      alert("please add products");
      return;
    }

    const batchSize = 500; // Define the size of each batch
    const maxRetries = 3; // Define the maximum number of retries for each batch

    // Split the jsonproducts array into smaller batches
    const totalProducts = jsonproducts.length;
    let batches = [];
    for (let i = 0; i < totalProducts; i += batchSize) {
      batches.push(jsonproducts.slice(i, i + batchSize));
    }

    const updateApi = axios.create({
      baseURL: `${server}/admin/updaterwproducts`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
      timeout: 10000,
    });

    // Send each batch one by one
    for (let i = 0; i < batches.length; i++) {
      const batch = batches[i];
      const batchNo = i;
      let retryCount = 0;
      let success = false;

      // Retry mechanism for each batch
      while (retryCount < maxRetries && !success) {
        const bulkOps = batch.map((product) => {
          // Destructure the fields from the product, giving a default value of `undefined` if not provided
          const {
            price,
            stock,
            productType,
            published,
            stocklimit,
            buyinglimit,
            name,
            net_weight,
            // imageUrl, // assuming you also want to update imageUrl
          } = product;

          // Validate that the `name` field is present
          if (!name) return null;

          // Build the update object
          const updateObj = {};

          // Conditionally add fields to the update object if they are present
          // if (price !== undefined) updateObj.price = price
          if (stock !== undefined) updateObj.stock = stock;
          if (productType !== undefined) updateObj.productType = productType;
          if (published !== undefined)
            updateObj.published = published === "FALSE" ? false : true;
          if (stocklimit !== undefined) updateObj.stocklimit = stocklimit;
          if (buyinglimit !== undefined) updateObj.buyinglimit = buyinglimit;
          if (net_weight !== undefined) updateObj.net_weight = net_weight;
          // if (imageUrl !== undefined) updateObj.imageUrl = imageUrl

          // Ensure there is at least one field to update before proceeding
          if (Object.keys(updateObj).length === 0) {
            // Skip if no fields are provided for the update
            return null;
          }

          // Create the bulk operation for updating the product
          return {
            updateOne: {
              filter: { name }, // Match by product name
              update: {
                $set: updateObj, // Only update the fields that are present
              },
            },
          };
        });

        // console.log(batch);
        // Remove any null values from the operations (invalid or empty updates)

        // If there are no valid operations to run
        if (bulkOps.filter(Boolean).length === 0) {
          toast.error("No valid products to update.");
          throw new Error({ error: "No valid products to update." });
        }
        try {
          const result = await updateApi.put(
            `${server}/admin/updaterwproducts`,
            { data: batch },
          );
          console.log("Batch processed successfully:", result);

          // If batch number is a multiple of 4, introduce a delay
          if (batchNo % 3 === 0) {
            console.log(
              batchNo,
              ": ",
              "Waiting for 2 seconds before next batch...",
              batchNo % 3 === 0,
            );
            await delay(4000);
          }

          success = true; // Mark success and break out of the retry loop
        } catch (error) {
          retryCount++;
          console.error(
            `Error processing batch ${
              i + 1
            }, retry attempt ${retryCount} of ${maxRetries}:`,
            error,
          );

          // If it's the last retry attempt, stop further retries
          if (retryCount === maxRetries) {
            console.error(
              `Failed to process batch ${i + 1} after ${maxRetries} retries.`,
            );
          } else {
            // Delay between retries, here you could implement exponential backoff or a fixed delay
            const retryDelay = 2000 * retryCount; // Delay increases with each retry
            console.log(`Retrying in ${retryDelay}ms...`);
            await delay(retryDelay);
          }
        }
      }
    }

    // console.log(result)
    //also call handleclose next and ser json back to empty
    setJson([]);
    handleClose();
  };

  const readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = xlsx.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = xlsx.utils.sheet_to_json(worksheet);
        // console.log(json);
        setJson(json);
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const [syncing, setSyncing] = useState(false);
  const [syncProgress, setSyncProgress] = useState({ progress: 0, msg: "" });
  const [syncIsDisabled, setSyncIsDisabled] = useState(false);

  // Predefined times (e.g., in 24-hour format: "11:00", "13:00", etc.)
  const times = ["11:00", "13:00", "15:00", "17:00", "19:00", "21:00"];

  // Function to check if the current time is within the 8-minute window
  const isWithinTimeWindow = (currentTime, targetTime) => {
    const [targetHour, targetMinute] = targetTime
      .split(":")
      .map((num) => parseInt(num, 10));

    const targetDate = new Date();
    targetDate.setHours(targetHour, targetMinute, 0, 0);

    const timeBefore = new Date(targetDate.getTime() - 10 * 60 * 1000); // 10 minutes before
    const timeAfter = new Date(targetDate.getTime() + 10 * 60 * 1000); // 10 minutes after

    // Check if the current time is within the 8-minute window before or after the target time
    return currentTime >= timeBefore && currentTime <= timeAfter;
  };

  // Function to check if button should be disabled
  const checkButtonStatus = () => {
    const currentTime = new Date();

    const shouldDisable = times.some((time) =>
      isWithinTimeWindow(currentTime, time),
    );
    setSyncIsDisabled(shouldDisable);
    return shouldDisable;
  };

  // UseEffect to check on mount
  useEffect(() => {
    checkButtonStatus();
  }, []);

  const callSyncApi = async () => {
    if (checkButtonStatus())
      return toast.error("Auto syncing currently please wait 20mins");
    socket.emit("sync-products");
    setSyncProgress({ progress: 5, msg: "Started sycing products.." });
    return;
    // try {
    //   setLoading(true);
    //   const result = await axios.get(`${server}/admin/sync-with-retailware`, {
    //     headers: {
    //       Authorization: `Bearer ${localStorage.getItem("accessToken")}`, // Attach the token to the Authorization header
    //     },
    //   });
    //   console.log(result);
    // } catch (error) {
    //   console.log(error.message);
    // }
    // setLoading(false);
  };

  const getSyncStaus = () => {
    axios
      .get(`${server}/admin/product_sync_status`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      })
      .then((res) => {
        setSyncProgress(res.data);
      })
      .catch((err) => console.log(err));
  };

  const exportToExcel = () => {
    if (products?.length > 0) {
      // Create a new array with transformed data
      const transformedProducts = products?.map((product) => ({
        vendor_sku: product?.rwId,
        name: product?.name,
        imageUrl: product.imageUrl,
        Category: product?.categoryId?.name,
        Subcategory: product?.subCategoryId?.name,
        mrpPrice: product?.mrpPrice,
        Stock: product?.stock,
        Stocklimit: product?.stocklimit,
        labelcode: product?.labelcode,
        Barcode: product?.barcode?.join(", ") || "",
        published: product?.published,
        price: product?.price,
        sales: product?.sales,
        productType: product?.productType,
      }));

      // Create a new workbook
      const workbook = xlsx.utils.book_new();

      // Convert the product data into a worksheet
      const worksheet = xlsx.utils.json_to_sheet(transformedProducts);

      // Append the worksheet to the workbook
      xlsx.utils.book_append_sheet(workbook, worksheet, "Products");

      // Export the workbook to an Excel file
      xlsx.writeFile(workbook, "Product_Inventory.xlsx");
    }
  };

  const getLowstockProducts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${server}/admin/lowstockproducts`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setProducts(response?.data);
      setLoading(false);
      console.log("low stock product ", response.data);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("adminuser")) navigate("/");
    setLoaded(true);

    if (!loaded) {
      getSyncStaus();
      dataProducts(true);
      // fetchLabelCodeData();

      socket.connect();
      socket.on("sync-products-update", (body) => setSyncProgress(body));
    }
    // return () => {
    //   socket.disconnect();
    // };
  }, [loaded]);

  useEffect(() => {
    if (
      syncProgress?.progress == -1 ||
      syncProgress?.msg?.startsWith("Error")
    ) {
      toast.error(
        "Error syncing products RetailWare API may be down!",
        topRightToastStyles,
      ) && console.log(syncProgress);
      setTimeout(() => {
        setSyncing(false);
      }, 5000);
      if (!loading) dataProducts();
    } else if (syncProgress?.progress == 100) {
      toast.success("Products synced!", topRightToastStyles);
      // && socket.disconnect();
      setTimeout(() => {
        setSyncing(false);
      }, 5000);
      if (!loading) dataProducts();
    } else if (syncProgress?.progress > 0) {
      !syncing && setSyncing(true);
    }
  }, [syncProgress]);

  // useEffect(() => {
  //   if (labelChecked) {
  //     fetchLabelCodeData();
  //   } else {
  //     if (!loading) dataProducts();
  //   }
  // }, [labelChecked]);

  // console.log({ labelChecked });

  return (
    <div>
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50vw",
            bgcolor: "background.paper",
            borderRadius: "12px",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: 1,
            }}
          >
            <Typography
              sx={{
                marginBottom: "10px",
                fontWeight: 500,
              }}
            >
              {" "}
              Upload Excel
            </Typography>
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                handleClose();
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="imageUpload-div">
              <div>
                <div className="upload-main-div">
                  <input
                    type="file"
                    id={`image-upload`}
                    // accept="image/*"
                    style={{ display: "none" }}
                    onChange={(event) => {
                      setfilename(event.target.files[0].name);
                      readUploadFile(event);
                    }}
                  />
                  {filename ? (
                    <label htmlFor="image-upload">
                      <div>
                        <img
                          alt="upload-img"
                          src={ExcelIcon}
                          className="upload-image"
                        />
                        <div className="upload-cloud-div">
                          <img
                            alt="upload-img"
                            src={UploadCloud}
                            className="upload-cloud"
                          />
                          <p className="upload-text">
                            Succesfully Uploaded Excel
                          </p>
                        </div>
                        <p className="upload-desc">
                          File uploaded - {filename}
                        </p>
                      </div>
                    </label>
                  ) : (
                    <label htmlFor="image-upload">
                      <div>
                        <img
                          alt="upload-img"
                          src={UploadImage}
                          className="upload-image"
                        />
                        <div className="upload-cloud-div">
                          <img
                            alt="upload-img"
                            src={UploadCloud}
                            className="upload-cloud"
                          />
                          <p className="upload-text">Upload Excel</p>
                        </div>
                        <p className="upload-desc">
                          Upload excel for your products.
                        </p>
                        <p className="upload-desc">
                          File Format <span>xlsx</span>
                        </p>
                      </div>
                    </label>
                  )}
                </div>
              </div>
            </div>

            <Button
              onClick={(e) => {
                e.preventDefault();
                UploadImagesInDB();
              }}
              sx={{
                backgroundColor: "#5570F1",
                width: "fit-content",
                textDecoration: "none",
                color: "#fff",
              }}
            >
              Submit File
            </Button>
          </Box>
        </Box>
      </Modal>

      <div className="order-head">
        <p className="order-title">Inventory Summary</p>
        {/* <Link
          to="/addproduct"
          state={{id:-1,isEdit: false }}
          style={{ textDecoration: "none" }}
        > */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 24,
          }}
        >
          <p
            className="order-title"
            style={{ display: "flex", alignItems: "center" }}
          >
            {syncProgress?.msg}
          </p>
          {syncing && (
            <>
              <CircularProgressWithLabel value={syncProgress?.progress ?? 0} />
            </>
          )}
          <button
            onClick={(e) => {
              e.preventDefault();
              callSyncApi();
            }}
            disabled={syncIsDisabled}
          >
            {/* <img alt="plus" src={Plus} /> */}
            {syncIsDisabled ? "Auto Syncing...." : "Sync Products"}
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              handleOpen();
            }}
          >
            <img alt="plus" src={Plus} />
            Upload Excel
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              exportToExcel();
            }}
          >
            Download Excel
          </button>
        </div>
        {/* </Link> */}
      </div>
      <div className="inventory-grid">
        <div className="allproducts">
          <Allproducts products={products} />
        </div>
        <div className="rating">
          <Rating
            products={products}
            fetchAllProducts={dataProducts}
            fetchLowStockProducts={getLowstockProducts}
          />
        </div>
      </div>
      <div>
        <InventoryTable
          products={
            !labelChecked
              ? products
              : products?.sort((a, b) => b?.labelcode - a?.labelcode) || []
          }
          fetchproducts={dataProducts}
          setName={setName}
          setCategory={setCategory}
          setSubcategory={setSubcategory}
          labelChecked={labelChecked}
          setLabelChecked={setLabelChecked}
        />
      </div>
    </div>
  );
};

export default Inventory;
